import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetQuestions } from "../../../services/questions";
import {
  fetchQuestionsStart,
  fetchQuestionsSuccess,
  fetchQuestionsFailure,
} from "../reducer";

function* getQuestions({ payload }) {
  const response = yield call(httpGetQuestions, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(fetchQuestionsSuccess(raw));
  } else {
    yield put(fetchQuestionsFailure(message || raw?.error));
  }
}

export default function* onGetQuestions() {
  yield takeLatest(fetchQuestionsStart.type, getQuestions);
}
